import preset from "../preset";

export const boxTextSizeClass = preset.pclasses('boxTextSize', ['size']);

export default boxTextSizeClass;
